import React from "react";
import { Conditional, Else, Heading, If, useSync } from "@hex-insights/core";
import { MarketEntranceStationForm, useMarketEntranceStationDetailQuery } from "@hex-insights/roadium.shared";
import { useActivePageRegistration } from "@hex-insights/router";
import { Main } from "../../../../Components";
import { marketEntranceStationHubDetailPageInfo } from "./pageinfo";

export function MarketEntranceStationHubDetailPage() {
	const { marketEntranceStationID } = marketEntranceStationHubDetailPageInfo.useParams();

	const { loading, data, error } = useMarketEntranceStationDetailQuery({
		variables: { id: marketEntranceStationID },
	});
	const { syncID, synchronize } = useSync();

	const marketEntranceStation = data?.marketEntranceStation;

	useActivePageRegistration(
		marketEntranceStationHubDetailPageInfo,
		!!marketEntranceStation ? marketEntranceStationHubDetailPageInfo.title(marketEntranceStation) : "",
	);

	return (
		<Main>
			<Conditional>
				<If condition={loading}>Loading...</If>
				<If condition={error !== undefined}>Error loading marketEntranceStation</If>
				<Else>
					{!!marketEntranceStation && (
						<React.Fragment>
							<Heading level={1}>{marketEntranceStation.name}</Heading>

							<MarketEntranceStationForm.ControlledDetail
								key={syncID}
								marketEntranceStation={marketEntranceStation}
								onSuccess={synchronize}
							/>
						</React.Fragment>
					)}
				</Else>
			</Conditional>
		</Main>
	);
}
